import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private baseConfig: MatSnackBarConfig = {
    duration: 5000,
    horizontalPosition: 'right',
    verticalPosition: 'top',
  };

  private CUSTOM_ERROR_MESSAGE = 'Se presentó un error, por favor intente nuevamente';

  constructor(private snackBarService: MatSnackBar, private translate: TranslateService) {}

  success(message: string, args: any[] = []) {
    const succesConfig: MatSnackBarConfig = { ...this.baseConfig, panelClass: 'notification-sucess' };

    const msgEntry = this.findKey(message).pipe(first());
    msgEntry.subscribe((msgEntry) => {
      const interpolatedMessage: string = this.interpolate(msgEntry, args);
      this.translate
        .get(interpolatedMessage)
        .pipe(first())
        .subscribe((mes) => this.snackBarService.open(mes, 'Cerrar', succesConfig));
    });
  }

  action(messageKey: string, actionKey: string, onAction: () => void): void {
    forkJoin([this.translate.get(messageKey), this.translate.get(actionKey)])
      .pipe(first())
      .subscribe(([message, actionLabel]) => {
        const ref = this.snackBarService.open(message, actionLabel, {
          ...this.baseConfig,
          duration: 8000,
        });
        ref.onAction().pipe(first()).subscribe(() => onAction());
      });
  }

  error(message: string | HttpErrorResponse | Error = null) {
    const errorConfig: MatSnackBarConfig = { ...this.baseConfig, panelClass: 'notification-error' };
    if (message instanceof HttpErrorResponse && message.status === 403) { 
      this.translate
        .get('ACCESS_DENIED')
        .pipe(first())
        .subscribe((mes) => this.snackBarService.open(mes, 'Cerrar', errorConfig));
      return;
    }
    
    if (message instanceof HttpErrorResponse) {
      this.translate
        .get(message.error.error.code || 'CUSTOM_ERROR_MESSAGE')
        .pipe(first())
        .subscribe((mes) => this.snackBarService.open(mes, 'Cerrar', errorConfig));
      return;
    }

    if (message instanceof Error) {
      this.translate
        .get(message.message || 'CUSTOM_ERROR_MESSAGE')
        .pipe(first())
        .subscribe((mes) => this.snackBarService.open(mes, 'Cerrar', errorConfig));
      return;
    }

    this.translate
        .get(message || 'CUSTOM_ERROR_MESSAGE')
        .pipe(first())
        .subscribe((mes) => this.snackBarService.open(mes, 'Cerrar', errorConfig));
        
  }

  private findKey(key: string) {
    return this.translate.get(key).pipe(first());
  }

  private interpolate(message: string, args: any[]) {
    args.forEach((value) => {
      message = message.replace('{{' + value.key + '}}', value.val);
    });

    return message;
  }
}
